
  var _styles = {
  "loading-more__container": {
    "justifyContent": "center",
    "alignItems": "flex-start"
  },
  "loading-more__sensor": {
    "width": "100%",
    "height": "100%"
  },
  "loading-more__button": {
    "borderRadius": "0.4rem",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)"
  },
  "loading-more__button-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "fontWeight": "400"
  }
};



  module.exports = _styles;
  